import { useTranslation } from 'react-i18next'
import SimpleButton from '../../../common/SimpleButton'
import PageModal from '../../../common/PageModal'
import { convertTimeWithTAndZ } from '../../../../utils/filters/date'
import '../../internal-reports.scss'

const ViewDeviceModal = (props) => {
  const { t } = useTranslation()
  const { selectedDevice, closeModal } = props

  const deviceFooterContent = () => {
    return (
      <>
        <SimpleButton className="cancel-button" onClick={closeModal}>
          {t('close')}
        </SimpleButton>
      </>
    )
  }

  return (
    <>
      <PageModal toggle onToggle={closeModal} className="device-modal" title={t('details')} footerContent={deviceFooterContent()}>
        <div className="registered-devices-modal-content">
          <div className="section-title">{t('general_information').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('serial_number')}</p>
              <div className="value">{selectedDevice.serialNumber}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('model')}</p>
              <div className="value">{selectedDevice.model}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('reports.device_registration_date')}</p>
              <div className="value">{convertTimeWithTAndZ(selectedDevice.deviceRegistrationDate).split(' ')[0]}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('report-form.cycle-count')}</p>
              <div className="value">{selectedDevice.cycleCount}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('device_context.online_access')}</p>
              <div className="value">{selectedDevice.onlineAccessStatus ? t('active') : t('inactive')}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('reports.online_access_activation_date')}</p>
              <div className="value">{selectedDevice.onlineAccessActivationDate}</div>
            </div>
          </div>

          <div className="separator" />

          <div className="section-title">{t('warranty.customer_info').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('name')}</p>
              <div className="value">{selectedDevice.name}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('email')}</p>
              <div className="value">{selectedDevice.email}</div>
            </div>
          </div>

          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('address')}</p>
              <div className="value">{selectedDevice.address || 'N/A'}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('city')}</p>
              <div className="value">{selectedDevice.city || 'N/A'}</div>
            </div>
          </div>

          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('state_province')}</p>
              <div className="value">{selectedDevice.state || 'N/A'}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('country')}</p>
              <div className="value">{selectedDevice.country}</div>
            </div>
          </div>

          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('zip_postal_code')}</p>
              <div className="value">{selectedDevice.postCode || 'N/A'}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('phone_number')}</p>
              <div className="value">{selectedDevice.phoneNumber || 'N/A'}</div>
            </div>
          </div>
        </div>
      </PageModal>
    </>
  )
}

export default ViewDeviceModal

